import { Injectable, inject } from '@angular/core';
import {
  Auth,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  signOut,
  user,
  User as FirebaseUser,
} from '@angular/fire/auth';
import { Observable } from 'rxjs';

/**
 * Authentication Service
 * Handles Firebase Authentication for users
 */
@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private auth = inject(Auth);
  
  // Observable of current Firebase user
  user$: Observable<FirebaseUser | null> = user(this.auth);

  /**
   * Sign in with email and password
   */
  async signIn(email: string, password: string): Promise<void> {
    await signInWithEmailAndPassword(this.auth, email, password);
  }

  /**
   * Create new user with email and password
   */
  async signUp(email: string, password: string): Promise<void> {
    await createUserWithEmailAndPassword(this.auth, email, password);
  }

  /**
   * Sign out current user
   */
  async signOut(): Promise<void> {
    await signOut(this.auth);
  }

  /**
   * Get current user ID
   */
  getCurrentUserId(): string | null {
    return this.auth.currentUser?.uid ?? null;
  }

  /**
   * Get current user
   */
  getCurrentUser(): FirebaseUser | null {
    return this.auth.currentUser;
  }
}
